import { render, staticRenderFns } from "./RiskClassificationForm.vue?vue&type=template&id=457d5b50"
import script from "./RiskClassificationForm.vue?vue&type=script&lang=js"
export * from "./RiskClassificationForm.vue?vue&type=script&lang=js"
import style0 from "./RiskClassificationForm.vue?vue&type=style&index=0&id=457d5b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports